import { useNavigate, useParams } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import EmpresaForm from './EmpresaForm'
import EmpresaLogoSection from './EmpresaLogoSection'
import {
  useEmpresaDetalhe,
  useEmpresaUpdate,
  type EmpresaFormData,
} from '../../hooks/useEmpresas'
import { extractApiError } from '../../lib/extractApiError'
import styles from '../_shared/CrudPage.module.css'

export default function EmpresaEditarPage() {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: empresa, isLoading } = useEmpresaDetalhe(id)
  const update = useEmpresaUpdate(id)

  async function handleSubmit(data: EmpresaFormData) {
    try {
      await update.mutateAsync(data)
      notifications.show({ color: 'green', message: 'Empresa atualizada.' })
      navigate(`/empresas/${id}`)
    } catch (err) {
      notifications.show({
        color: 'red',
        title: 'Falha ao atualizar empresa',
        message: extractApiError(err, 'Verifique os campos.'),
      })
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            type="button"
            onClick={() => navigate(-1)}
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>
            {empresa?.razao_social || 'Editar empresa'}
          </h1>
        </div>
      </header>
      {isLoading ? (
        <p>Carregando...</p>
      ) : empresa ? (
        <>
          <EmpresaLogoSection empresaId={empresa.id} logoUrl={empresa.logo_url} />
          <EmpresaForm
            initial={empresa}
            onSubmit={handleSubmit}
            isLoading={update.isPending}
            submitLabel="Salvar alterações"
          />
        </>
      ) : (
        <p>Empresa não encontrada.</p>
      )}
    </div>
  )
}
